import React, { useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { Icon } from '../icon';
import { CustomButton, Image, PopContainer, PopoverArea, MainContent } from './mixins';
// global time controls
const POP_TIMEOUT = 5000;
const DISMISSTIME = 300;
export const PopOverComponent = ({ children, imgSrc, content, visible, onClose, arrowProps, fullwidth, id, autoHide = true, }) => {
    const [dismissPop, setDismissPop] = useState(false);
    const [timeIsUp, setTimeIsUp] = useState(false);
    // volvemos todo los controladores a su estado default
    const handleTurnOff = () => {
        onClose();
        setDismissPop(true);
        setTimeIsUp(false);
    };
    const [remainTime] = useState(() => debounce(() => setTimeIsUp(true), POP_TIMEOUT));
    const [dissmisTime] = useState(() => debounce(() => {
        handleTurnOff();
    }, DISMISSTIME));
    useEffect(() => {
        if (visible && !timeIsUp) {
            setDismissPop(false);
            if (autoHide) {
                remainTime();
            }
        }
        if (!visible || timeIsUp) {
            dissmisTime();
        }
    }, [autoHide, visible, timeIsUp]);
    return (React.createElement(PopoverArea, { id: `popover-${id}`, fullwidth: fullwidth },
        children,
        !dismissPop && (React.createElement(PopContainer, { isVisible: visible && !timeIsUp, setArrowPos: visible && !timeIsUp ? arrowProps : 'hide' },
            imgSrc && React.createElement(Image, { src: imgSrc, alt: "Pop image alert" }),
            React.createElement(MainContent, null, content),
            React.createElement(CustomButton, { onClick: onClose, buttonoptions: {
                    variant: 'black',
                    size: 'medium',
                    type: 'link',
                } },
                React.createElement(Icon, { name: "icon-light-close", color: "#000018", size: "24" }))))));
};
